import clip from '@/lib/clipboard/Clippy.js'

export default {
  install (Vue, options) {
    Vue.prototype.$clip = clip
  }
}
